export const TypingDots = () => (
    <span className="chat-typing-bubble__dots" aria-hidden="true">
        <span className="chat-typing-bubble__dot" />
        <span className="chat-typing-bubble__dot" />
        <span className="chat-typing-bubble__dot" />
    </span>
);

/** Burbuja de «escribiendo…» dentro del hilo de mensajes. */
export const TypingBubble = ({ isOwn = false, senderName = '' }) => (
    <div
        className={[
            'chat-message',
            'chat-typing-bubble',
            isOwn ? 'chat-message--own' : '',
            'chat-message--in-view',
        ].filter(Boolean).join(' ')}
        aria-live="polite"
        aria-label={isOwn ? 'Escribiendo' : `${senderName || 'Alguien'} está escribiendo`}
    >
        <div className="chat-message__body">
            {!isOwn && senderName ? (
                <span className="chat-message__sender">{senderName}</span>
            ) : null}

            {isOwn ? (
                <span className="chat-message__sender chat-message__sender--own">Tú</span>
            ) : null}

            <div
                className={[
                    'chat-typing-bubble__bubble',
                    isOwn ? 'chat-typing-bubble__bubble--own' : '',
                ].filter(Boolean).join(' ')}
            >
                <TypingDots />
            </div>
        </div>
    </div>
);
